import PageHeader from "@/components/ui-kit/page-header"
import Alert from "@/components/ui-kit/alert"

export default function NotFound404Portal() {
    return <>
        <PageHeader
            pageName="Ikke funnet"
            pageDescription="Klarte ikke finne innholdet du lette etter..."
        />

        <div className="page-content">
            <Alert message="Fant ikke siden du lette etter..." color="danger"/>
        </div>
    </>
}
